export enum EtatDemandeModification {
  A_FAIRE = "A faire",
  ARCHIVEE = "Archivée"
}